var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleRight = function SvgAngleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 6 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53.47A.75.75 0 0 0 .47 1.53zM5 5l.53.53a.75.75 0 0 0 0-1.06zM.47 8.47a.75.75 0 0 0 1.06 1.06zm0-6.94 4 4 1.06-1.06-4-4zm4 2.94-4 4 1.06 1.06 4-4z"
  })));
};
export default SvgAngleRight;